import { ReactComponent as Next } from 'assets/icons/next.svg';
import { ReactComponent as Previous } from 'assets/icons/previous.svg';
import React, { useEffect, useRef, useState } from 'react';
import { LivechatMessageModel } from '@mm/state/model/LivechatMessageModel';
import { GalleryElement } from '../GalleryElement/GalleryElement';
import { messageStructureParser } from '../messageStructureParser';
import './GalleryDisplay.pcss';

type Props = { message: LivechatMessageModel };

export const GalleryDisplay = ({ message }: Props) => {
  const [scrollIndex, setScrollIndex] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const { getGalleryElements, getGalleryImageAspectRatio } =
    messageStructureParser(message);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = Math.max(0, 250 * scrollIndex);
    }
  }, [scrollIndex, containerRef.current]);

  const elements = getGalleryElements();

  if (!elements) {
    return null;
  }
  return (
    <div className="lc-gallery-display">
      <div ref={containerRef} className="lc-gallery-display__elements">
        {elements.map((element, idx) => (
          <GalleryElement
            element={element}
            key={idx}
            imageAspectRatio={getGalleryImageAspectRatio()}
          />
        ))}
      </div>
      {scrollIndex > 0 && (
        <div
          className="lc-gallery-display__previous"
          onClick={() => setScrollIndex(Math.max(0, scrollIndex - 1))}
        >
          <Previous />
        </div>
      )}
      {scrollIndex < elements.length - 1 && (
        <div
          className="lc-gallery-display__next"
          onClick={() =>
            setScrollIndex(Math.min(elements.length - 1, scrollIndex + 1))
          }
        >
          <Next />
        </div>
      )}
    </div>
  );
};
